export function normalizeTimeZone(timeZone: string | null): string {
    if (!timeZone || timeZone === 'null') {
        return 'Asia/Kolkata';
    }

    const mapping: Record<string, string> = {
        'Europe/Kiev': 'Europe/Kyiv',
        'Asia/Chungking': 'Asia/Chongqing',
        'Asia/Harbin': 'Asia/Shanghai',
        'Asia/Rangoon': 'Asia/Yangon',
        'Asia/Djakarta': 'Asia/Jakarta',
        'Asia/Tel_Aviv': 'Asia/Jerusalem',
        'Asia/Calcutta': 'Asia/Kolkata'
    };

    return mapping[timeZone] || timeZone;
}

export function formatTimeBasedOnTimezone(isoString: string): string {
    if (!isoString) return 'N/A';
    try {
        const date = new Date(isoString);
        const timeZone = normalizeTimeZone(localStorage.getItem('user_time_zone'));

        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: timeZone
        });
    } catch {
        return isoString;
    }
}


